module.exports = __webpack_public_path__ + "Body_DiffuseColor.a18f02b.basis";